import { register } from "../../../JavaScript/Utils";

declare global {
  interface Window {
    Splide?: Splide;
    splide?: any;
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any;

export const ServiceTable = (el: HTMLElement) => {
  const serviceTables = el.querySelectorAll(".comp-service-table");
  const priceValues = el.querySelectorAll(".price");
  const prices: { price: string; doubledPrice: string }[] = [];

  const serviceTablesButtons = el.querySelectorAll(
    ".comp-service-table--option-content-btn"
  );
  const buttonsLabelWearInsurance = el.querySelectorAll(
    ".labelWearInsurance"
  ) as NodeListOf<HTMLSpanElement>;

  const headlineInsuranceType = el.querySelectorAll(
    ".comp-service-table--headline-insurance-type"
  ) as NodeListOf<HTMLSpanElement>;

  const serviceTableHiddenFootnotes = el.querySelectorAll(
    ".comp-service-table--hidden-footnote"
  ) as NodeListOf<HTMLParagraphElement>;

  const chevronToggles = el.querySelectorAll(
    ".chevron-toggle"
  ) as NodeListOf<HTMLElement>;

  const priceHints = el.querySelectorAll(
    ".comp-blog-listing-select--price-hint"
  ) as NodeListOf<HTMLElement>;

  chevronToggles.forEach((chevronToggle) => {
    const optionContent = chevronToggle.parentElement;

    chevronToggle.addEventListener("click", () => {
      optionContent.classList.toggle("expanded");
    });
  });

  priceValues.forEach((priceValue: Element) => {
    const price: string = priceValue.textContent.trim();
    const priceNumber: number = parseFloat(
      price.replace(",", ".").replace("€", "")
    );
    const doubledPrice: string = (priceNumber * 2).toFixed(2).replace(".", ",") + " €";
    prices.push({ price: price, doubledPrice: doubledPrice });
  });

  const togglePrices = (doubledPrice: boolean) => {
    priceValues.forEach((priceValue, index) => {
      priceValue.innerHTML = doubledPrice
        ? prices[index].price
        : prices[index].doubledPrice;
    });
  };

  const tooglePriceHint = (showPriceHint: boolean) => {
    priceHints.forEach((priceHint, index) => {
      if (showPriceHint) {
        priceHint.classList.add("d-none");
      } else {
        priceHint.classList.remove("d-none");
      }
    });
  }

  serviceTablesButtons.forEach((serviceTablesButton, index) => {
    const labelRemove = buttonsLabelWearInsurance[index].dataset.labelRemove;
    const labelAdd = buttonsLabelWearInsurance[index].dataset.labelAdd;
    const headlineComfortInsurance = headlineInsuranceType[index].dataset.headlineComfortInsurance;
    const headlineWearInsurance = headlineInsuranceType[index].dataset.headlineWearInsurance;




    serviceTablesButton.addEventListener("click", () => {
      if (serviceTables[index].classList.contains("full-service")) {
        // Case Comfort Insurance
        serviceTables[index].classList.remove("full-service");
        buttonsLabelWearInsurance[index].innerHTML = labelAdd;
        serviceTableHiddenFootnotes[index].classList.add("d-none");
        priceHints[index].classList.add("d-none");
        headlineInsuranceType[index].innerHTML = headlineComfortInsurance;
        tooglePriceHint(true);
        togglePrices(true);
      } else {
        // Case Wear Insurance
        serviceTables[index].classList.add("full-service");
        buttonsLabelWearInsurance[index].innerHTML = labelRemove;
        serviceTableHiddenFootnotes[index].classList.remove("d-none");
        priceHints[index].classList.remove("d-none");
        headlineInsuranceType[index].innerHTML = headlineWearInsurance;
        tooglePriceHint(false);
        togglePrices(false);
      }
    });
  });

  const init = () => {
    const Splide = window.Splide;
    const sliderContainer = el.querySelector(".splide-wrapper");
    const ServiceTable = new Splide(sliderContainer, {
      type: "fade",
      swipe: false,
      arrows: false,
      perPage: 1,
      perMove: 1,
      autoplay: false,
      mediaQuery: "min",
      isNavigation: true,
      gap: "1rem",
      pagination: el.dataset.pagination || true,
      padding: el.dataset.noLoop
        ? { right: el.dataset.mobilePadding || 0 }
        : el.dataset.mobilePadding || 0,
      classes: {
        pagination: "splide__pagination pagination",
        page: "splide__pagination__page page-bubble cursor-pointer",
      },
      updateOnMove: true,
      breakpoints: {
        768: {
          perPage: 1,
        },
        1024: {
          perPage: +el.dataset.perPage || 1,
          destroy: el.dataset.mobileOnly || false,
          padding: el.dataset.noLoop
            ? { right: el.dataset.desktopPadding || 0 }
            : el.dataset.desktopPadding || 0,
        },
      },
    });
    ServiceTable.mount();
  };
  init();
};

register("ServiceTable", ServiceTable);
